import Immutable from 'seamless-immutable';
import * as _ from "../../../../util/lodash";
import { createAction, createReducer } from 'redux-act';
var NAMESPACE = 'CK => animating button =>';
var registerButton = createAction(NAMESPACE + " register button", function (id, actions) {
  return {
    id: id,
    actions: actions
  };
});
var deregisterButton = createAction(NAMESPACE + " deregister button", function (id) {
  return {
    id: id
  };
});
var startAnimation = createAction(NAMESPACE + " start animation", function (id) {
  return {
    id: id
  };
});
var finishAnimation = createAction(NAMESPACE + "  finish animation", function (id) {
  return {
    id: id
  };
});
var success = createAction(NAMESPACE + " success", function (id) {
  return {
    id: id
  };
});
var failure = createAction(NAMESPACE + " failure", function (id) {
  return {
    id: id
  };
});
var initialState = Immutable({
  byId: {}
});
export var reducer = createReducer(function (on) {
  on(registerButton, function (state, _ref) {
    var id = _ref.id;
    return state.setIn(['byId', id], {
      isAnimating: false,
      isSuccess: false,
      isFailure: false
    });
  });
  on(deregisterButton, function (state, _ref2) {
    var id = _ref2.id;
    return state.set('byId', state.byId.without(id));
  });
  on(startAnimation, function (state, _ref3) {
    var id = _ref3.id;
    return state.setIn(['byId', id], {
      isAnimating: true,
      isSuccess: false,
      isFailure: false
    });
  });
  on(success, function (state, _ref4) {
    var id = _ref4.id;
    return state.setIn(['byId', id], {
      isAnimating: false,
      isSuccess: true,
      isFailure: false
    });
  });
  on(failure, function (state, _ref5) {
    var id = _ref5.id;
    return state.setIn(['byId', id], {
      isAnimating: false,
      isSuccess: false,
      isFailure: true
    });
  });
  on(finishAnimation, function (state, _ref6) {
    var id = _ref6.id;
    return state.setIn(['byId', id], {
      isAnimating: false,
      isSuccess: false,
      isFailure: false
    });
  });
}, initialState);
export var Actions = {
  registerButton: registerButton,
  deregisterButton: deregisterButton,
  startAnimation: startAnimation,
  finishAnimation: finishAnimation,
  success: success,
  failure: failure
};

var _scopeState = function _scopeState(state) {
  return state.ck.animatingButton;
};

var makeAnimatingButtonSelectorById = function makeAnimatingButtonSelectorById(id) {
  return {
    isAnimating: function isAnimating(state) {
      return _.get(_scopeState(state), ['byId', id, 'isAnimating'], false);
    },
    isSuccess: function isSuccess(state) {
      return _.get(_scopeState(state), ['byId', id, 'isSuccess'], false);
    },
    isFailure: function isFailure(state) {
      return _.get(_scopeState(state), ['byId', id, 'isFailure'], false);
    }
  };
};

export var Selectors = {
  makeAnimatingButtonSelectorById: makeAnimatingButtonSelectorById
};
//# sourceMappingURL=animating-button-duck.js.map